export const elName = "dob-input-component";

const template = document.createElement("template");
template.innerHTML = `
<style>

* {
-webkit-font-smoothing:antialiased;
}

</style>
<link href="${(window as any)["common/generated/common-bundle.css.ftl"]}" rel="stylesheet"/>
<div id="dob-label" class="divider__label"><label>Geburtsdatum</label></div>
<div class="form__group" role="group">
<div class="form__multifield">
    <div class="form__group-item" data-autotab="">
        <label for="dob_day" class="form__label-fixed">Tag</label>
        <input
            class="form__input"
            value=""
            placeholder="TT"
            type="text"
            maxlength="2"
            inputmode="numeric"
            pattern="\d{1,2}"
            id="dob_day">
    </div>
    <div class="form__group-item" data-autotab="">
        <label for="dob_month" class="form__label-fixed">Monat</label>
        <input
            class="form__input"
            value=""
            placeholder="MM"
            type="text"
            maxlength="2"
            inputmode="numeric"
            pattern="\d{1,2}"
            id="dob_month">
    </div>
    <div class="form__group-item" data-autotab="">
        <label for="dob_year" class="form__label-fixed">Jahr</label>
        <input
            class="form__input"
            value=""
            placeholder="JJJJ"
            type="text"
            maxlength="4"
            inputmode="numeric"
            pattern="\d{1,4}"
            id="dob_year">
    </div>
  </div>
  <span class="form__error qa-update-profile-last-name-error" hidden="" aria-live="polite"></span>
</div>
`;

export class DobInputComponent extends HTMLElement {
  private yearInput: HTMLInputElement;
  private monthInput: HTMLInputElement;
  private dayInput: HTMLInputElement;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(template.content.cloneNode(true));

    this.yearInput = this.shadowRoot.getElementById(
      "dob_year",
    ) as HTMLInputElement;
    this.monthInput = this.shadowRoot.getElementById(
      "dob_month",
    ) as HTMLInputElement;
    this.dayInput = this.shadowRoot.getElementById(
      "dob_day",
    ) as HTMLInputElement;

    this.yearInput.addEventListener(
      "input",
      (_) =>
        (this.yearInput.value = this.yearInput.value
          .replace(/[^0-9]/g, "")
          .substring(0, 4)),
    );
    this.monthInput.addEventListener(
      "input",
      (_) =>
        (this.monthInput.value = this.monthInput.value
          .replace(/[^0-9]/g, "")
          .substring(0, 2)),
    );
    this.dayInput.addEventListener(
      "input",
      (_) =>
        (this.dayInput.value = this.dayInput.value
          .replace(/[^0-9]/g, "")
          .substring(0, 2)),
    );

    this.handleDayInput = this.handleDayInput.bind(this);
    this.handleMonthInput = this.handleMonthInput.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.fillDobInput = this.fillDobInput.bind(this);
    this.setRedBorder = this.setRedBorder.bind(this);
    this.removeRedBorder = this.removeRedBorder.bind(this);
  }

  connectedCallback() {
    const valueAttribute = this.getAttribute("value");
    if (valueAttribute) {
      const [year, month, day] = valueAttribute.split("-");
      this.yearInput.value = year;
      this.monthInput.value = month;
      this.dayInput.value = day;
    }

    this.monthInput.addEventListener("input", this.handleMonthInput);
    this.dayInput.addEventListener("input", this.handleDayInput);

    this.yearInput.addEventListener("change", this.fillDobInput);
    this.monthInput.addEventListener("change", this.fillDobInput);
    this.dayInput.addEventListener("change", this.fillDobInput);

    this.monthInput.addEventListener("blur", this.handleBlur);
    this.dayInput.addEventListener("blur", this.handleBlur);
  }

  static get observedAttributes() {
    return ["error-message", "value", "day-error", "month-error", "year-error"];
  }

  attributeChangedCallback(name: string, _oldValue: any, newValue: string) {
    if (name.includes("error")) {
      const errorMessage = this.shadowRoot.querySelector(
        ".form__error",
      ) as HTMLSpanElement;
      if (newValue) {
        const input = name.split("-")[0];
        const inputElement = this.shadowRoot.getElementById(
          `dob_${input}`,
        ) as HTMLInputElement;
        errorMessage.textContent = newValue;
        errorMessage.hidden = false;
        this.setRedBorder(inputElement || undefined);
      } else {
        errorMessage.textContent = "";
        errorMessage.hidden = true;
        this.removeRedBorder();
      }
      // Update shadow DOM or internal state with the new error
    }
    if (name === "value") {
      if (newValue) {
        const [year, month, day] = newValue.split("-");
        // fire change events
        this.yearInput.value = year;
        this.monthInput.value = month;
        this.dayInput.value = day;
      } else {
        this.yearInput.value = "";
        this.monthInput.value = "";
        this.dayInput.value = "";
      }
      this.fillDobInput();
    }
  }

  private handleDayInput(changeEvent: InputEvent) {
    const target = changeEvent.target as HTMLInputElement;
    if (target.value.length >= 2) {
      changeEvent.preventDefault();
    }
    if (target.value.length > 1) {
      this.monthInput.focus();
    }
  }

  private handleMonthInput(changeEvent: Event) {
    const target = changeEvent.target as HTMLInputElement;
    if (target.value.length >= 2) {
      changeEvent.preventDefault();
    }
    if (target.value.length > 1) {
      this.yearInput.focus();
    }
  }

  private handleBlur(event: Event): void {
    // add a zero before the month and day if they are less than 10
    const target = event.target as HTMLInputElement;
    const value = target.value;
    if (value.startsWith("0")) return;
    if (parseInt(value) < 10 && value.length === 1) {
      target.value = "0" + value;
    }
    this.fillDobInput();
  }

  private setRedBorder(input?: HTMLInputElement) {
    if (input) {
      input.classList.add("form__input--invalid");
      return;
    }
    this.shadowRoot.querySelectorAll("input").forEach((el) => {
      el.classList.add("form__input--invalid");
    });
  }

  private removeRedBorder() {
    this.shadowRoot.querySelectorAll("input").forEach((el) => {
      el.classList.remove("form__input--invalid");
    });
  }

  private fillDobInput() {
    const year = this.yearInput.value;
    const month = this.monthInput.value;
    const day = this.dayInput.value;
    // YYYY-MM-DD
    const dobElement = document.querySelector("#dob");
    if (dobElement) {
      const value =
        !year && !month && !day
          ? ""
          : `${year || ""}-${month || ""}-${day || ""}`;
      dobElement.setAttribute("value", value);
    }
  }
}

customElements.define(elName, DobInputComponent);
